import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useFeedbackPopup } from 'hooks/useFeedbackPopup';

export const Footer: React.FC = () => {
  const { FeedbackPopup, openFeedbackPopup } = useFeedbackPopup();

  const handleSendFeedback = useCallback(() => {
    openFeedbackPopup();
  }, [openFeedbackPopup]);

  return (
    <>
      <footer className="app-footer mt-auto w-full pb-[calc(env(safe-area-inset-bottom)+5rem)] font-body-s lg:pb-0">
        <div className="mx-auto flex max-w-5xl flex-row flex-wrap items-center justify-center gap-x-5 gap-y-2 px-4 py-4 text-sm text-muted-foreground sm:gap-6 sm:px-6 sm:py-6">
          <Link to="/" className="hover:text-foundation-base-darkbase-dark-400">
            Home
          </Link>
          <Link to="/contact" className="hover:text-foundation-base-darkbase-dark-400">
            Contact Us
          </Link>
          <button
            type="button"
            onClick={handleSendFeedback}
            className="bg-transparent p-0 border-0 hover:text-foundation-base-darkbase-dark-400 transition-colors focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foundation-base-darkbase-dark-400"
          >
            Send Feedback
          </button>
          <span className="order-last w-full text-center text-xs sm:order-none sm:w-auto sm:text-sm">
            {new Date().getFullYear()} Wise Friend. All rights reserved.
          </span>
          <a href="/privacy" className='hover:text-foundation-base-darkbase-dark-400'>
            Privacy
          </a>
          <a href="/terms" className='hover:text-foundation-base-darkbase-dark-400'>
            Terms of Service
          </a>
        </div>
      </footer>
      {FeedbackPopup}
    </>
  );
};
